import React, { useEffect, useMemo, useState } from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./EventUserCount.scss";
import { Locale } from '../../../../assets/Locale';
import { useBeam } from '@randajan/bifrost/client/react';
import { eventBeam } from '../../../../assets/beams/eventBeam';
import { Counter } from '@randajan/jet-react/dom/counter';

export const EventUserCount = (props)=>{
    const { value, row } = props;
    const say = Locale.use();

    const { data:event } = useBeam(eventBeam, [row.id]);

    const toMin = row.minUsers - value;
    const toMax = row.maxUsers - value;

    const showToMin = toMin > 0;
    const currentUsers = event?.gameEventUsers?.length ?? value;

    return (
        <Block className="EventUserCount">
            <Counter duration={Number.jet.rnd(250, 500)}>{currentUsers}</Counter>
            <span>/</span>
            <span className="fakeCounter">{row.maxUsers}</span>
        </Block>
    )
}

